// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__KBC-F","label":"Section_label__1NCOy","contentWrap":"Section_contentWrap__2Z0tj","footer":"Section_footer__1Zu3w","footerInner":"Section_footerInner__tmUU4"};